const SHARE_CLASS = {
  COMMON: 'common',
  PREFERRED: 'preferred'
};

module.exports = SHARE_CLASS;


/** WEBPACK FOOTER **
 ** /Users/dlopuch/developer/projects-venture-dealr/~/jshint-loader!./models/ShareClass.js
 **/